import React from 'react';

import { Card, CardContent } from '@mui/material';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';

import BlurImg from '../../assets/images/blurred_image.png';
import { TngGrid, TngImage, TngTypography } from '../../components/common';
import { RootState } from '../../store';

interface dashboardCardProps {
  label: string;
  link: string;
  linkTo: string;
  value: number;
}

const dashboardCardValues: dashboardCardProps[] = [
  { label: 'Credit Hold', link: 'View all', linkTo: '#', value: 7 },
  { label: 'Pending Fullfillment', link: 'View all', linkTo: '#', value: 7 },
  { label: 'Fulfilled', link: 'View all', linkTo: '#', value: 4 },
  { label: 'Billed', link: 'View all', linkTo: '#', value: 3 },
];

const Dashboard = () => {
  const authState = useSelector((state: RootState) => state.auth);
  const userName = authState?.username.split(' ');

  return (
    <TngGrid container className="dashboard_parent_container">
      <TngGrid container className="dashboard_child_container">
        <TngGrid item xs={12} className="dashboard_main_heading">
          <TngTypography>Welcome, {userName[0]}</TngTypography>
        </TngGrid>
        {dashboardCardValues.map((cardValue) => (
          <TngGrid
            key={cardValue.label}
            item
            xs={12}
            sm={12}
            md={6}
            lg={6}
            className="dashboard_card_grid"
          >
            <Card>
              <CardContent>
                <TngGrid item className="dashboard_cardcontentlabel_grid">
                  <TngTypography>{cardValue.label}</TngTypography>
                  <Link className="dashboard_card_link" to={cardValue.linkTo}>
                    {cardValue.link}
                  </Link>
                </TngGrid>
                <TngGrid item className="dashboard_cardcontentvalue_grid">
                  <TngTypography>{cardValue.value}</TngTypography>
                </TngGrid>
              </CardContent>
            </Card>
          </TngGrid>
        ))}
        <TngGrid item xs={12} className="dashboard_main_img">
          <TngImage src={BlurImg} alt="Dashboard image" className="dashboard_img" />
        </TngGrid>
      </TngGrid>
    </TngGrid>
  );
};

export default Dashboard;
